var map = {
	"./": 6194,
	"./english": 4177,
	"./english.json": 4177,
	"./french": 8982,
	"./french.json": 8982,
	"./index": 6194,
	"./index.json": 6194,
	"./other": 728,
	"./other.json": 728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3834;